import {Stack, Tooltip, Typography, useMediaQuery} from '@mui/material'
import { isNull, isUndefined, map } from 'lodash'
import CircleInformationIcon from '../../assets/icons/CircleInformation.svg'
import {theme} from "../../theme";

export const ReplyCost = ({ replyCost }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const ReplyCostMap = {
        TEXT: ' текст ',
        IMAGE: ' изобр.  ',
        AUDIO: ' аудио  ',
        VIDEO: ' видео  ',
        SPEECH: ' речь  ',
    }
    return (
        <>
            <Stack
                direction="row"
                gap={0.5}
                sx={{ justifyContent: 'center', alignItems: 'flex-end' }}>
                <Typography
                    sx={{
                        display: isMobile ? 'inline': 'flex',
                        lineHeight: ' 16px',
                        color: '#5A5F72',
                        fontSize: '12px',
                        fontWeight: '400',
                    }}>
                    Стоимость:
                    {isUndefined(replyCost)
                        ? ' 0 коинов'
                        : map(replyCost, (cost, index) => {
                              const price = isNull(cost.approximate_price)
                                  ? `${cost.minimum_price}-${cost.maximum_price}`
                                  : `~${cost.approximate_price}`
                              const separate = index + 1 < replyCost.length ? ' · ' : 'коинов'
                              return `${ReplyCostMap?.[cost.model_type]}${price} ${separate}`
                          })}
                    <Tooltip
                        title="Стоимость ориентировочная и может отличаться в зависимости от модели и контекста запроса"
                        placement="bottom-start">
                        <Stack sx={{ position: 'relative', top: isMobile ? '4px': '0px', left: ' 2px', display: 'inline' }}>
                            <CircleInformationIcon
                                color="#5A5F72"
                                style={{ width: '16px', height: '16px' }}
                            />
                        </Stack>
                    </Tooltip>
                </Typography>
            </Stack>
        </>
    )
}
